import moment from "moment";

export const getApplicationDisplayDate = (date: Date) => {
  const isToday = moment(date).diff(moment(new Date()), "days") >= 0;
  return isToday ? "common.date.today" : moment(date).format("DD-MM-YYYY");
}
